module.exports = __webpack_public_path__ + "static/hero-image-desktop-faddafa385d35aab2998208577fa505e.jpg";